import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ApiError } from "../lib/api";
import { ssoExchange } from "../lib/auth";

export function SsoBridgePage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const hubToken = params.get("token");
    const next = params.get("next") ?? "/";
    const safeNext = next.startsWith("/") && !next.startsWith("//") ? next : "/";

    if (!hubToken) {
      navigate("/login", { replace: true });
      return;
    }

    let cancelled = false;
    ssoExchange(hubToken)
      .then(() => {
        if (!cancelled) window.location.replace(safeNext);
      })
      .catch((err) => {
        if (cancelled) return;
        const msg =
          err instanceof ApiError && err.status === 401
            ? "Hub-Token abgelehnt. Bitte erneut vom Hub aus starten."
            : "SSO-Anmeldung fehlgeschlagen.";
        setError(msg);
      });

    return () => {
      cancelled = true;
    };
  }, [params, navigate]);

  return (
    <div className="mx-auto flex min-h-screen max-w-md items-center justify-center px-4 text-slate-300">
      {error ? (
        <div className="rounded border border-red-700 bg-red-900/40 px-4 py-3">
          <p>{error}</p>
          <button
            type="button"
            className="mt-3 text-sky-400 underline"
            onClick={() => navigate("/login", { replace: true })}
          >
            Zur Anmeldung
          </button>
        </div>
      ) : (
        <p>Anmeldung …</p>
      )}
    </div>
  );
}
